<template>
  <div class="pa-0">
    <div class="setting-item mb-4">
      <v-switch
        v-model="settings.global_restaurant_time_settings"
        :label="$t('global_restaurant_time_settings')"
        inset
        color="primary"
        hide-details
      />
    </div>

    <div v-show="settings.global_restaurant_time_settings">
      <v-divider class="my-4"></v-divider>

      <div class="text-center mb-4">
        <p class="subtitle-1 text-uppercase font-weight-bold">
          {{ $t("order_dead_line") }}
        </p>
      </div>

      <div
        v-for="day in weekDays"
        :key="day.value"
        class="day-card mb-3 pa-3 grey lighten-4 rounded"
      >
        <v-row dense>
          <v-col cols="12" sm="2" class="subtitle-2 text-uppercase font-weight-bold">
            <p class="mt-7 mb-0">{{ $t(day.label) }}</p>
          </v-col>

          <v-col cols="12" sm="2">
            <text-field
              :label="$t('day_before_limit')"
              type="number"
              v-model="settings.days[day.value].day_before_limit"
              color="white"
              dense
              hide-details
            />
          </v-col>

          <v-col cols="auto" class="text-center hidden-xs-only">
            <v-icon small class="mt-8">mdi-chevron-left</v-icon>
          </v-col>

          <v-col cols="12" sm="5">
            <v-row dense>
              <v-col cols="6">
                <autocomplete
                  :items="deliveryHours"
                  item-value="val"
                  v-model="settings.days[day.value].time.time_hour"
                  :label="$t('starting_from_h')"
                  color="white"
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="6">
                <autocomplete
                  :items="deliveryMinutes"
                  item-value="val"
                  v-model="settings.days[day.value].time.time_minut"
                  :label="$t('up_to_min')"
                  color="white"
                  dense
                  hide-details
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="auto" class="text-center hidden-xs-only">
            <v-icon small class="mt-8">mdi-chevron-right</v-icon>
          </v-col>

          <v-col cols="12" sm="2">
            <text-field
              :label="$t('day_after_limit')"
              type="number"
              v-model="settings.days[day.value].day_after_limit"
              color="white"
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WeeklyTimeSettingsTab",
  props: {
    settings: {
      type: Object,
      required: true,
    },
    deliveryHours: {
      type: Array,
      required: true,
    },
    deliveryMinutes: {
      type: Array,
      required: true,
    },
    weekDays: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.setting-item {
  min-height: 48px;
  display: flex;
  align-items: center;
}

.setting-label {
  display: flex;
  align-items: center;
}

.day-card {
  transition: all 0.2s;
}

.day-card:hover {
  background-color: #f5f5f5 !important;
}
</style>
